<template>
  <div v-if="isShow && template">
    <header>
      ひとことテンプレート
      <div class="h-left">
        <a  @click="$emit('close')"
          ><img src="~@/assets/images/icon02.svg"
        /></a>
      </div>
    </header>
    <div id="wrap">
      <div
        class="template"
        v-for="(item, index) in template[TEMPLATE_TYPE_MOOD_STATUS]"
        :key="index"
      >
        {{ item }}
        <div class="btn1">
          <a  @click="setValue(item)">このテンプレートを使う</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/constants";
export default {
  props: {
    isShow: Boolean,
  },
  emits: ['close'],
  data: () => ({
    value: null,
    TEMPLATE_TYPE_MOOD_STATUS: CONSTANTS.TEMPLATE_TYPE_MOOD_STATUS,
    template: null
  }),
  computed: {
    ...mapGetters(["metadata", "profileTemplate", "defaultToken"]),
  },
  mounted() {
    if (!this.profileTemplate) {
      this.getProfileTemplate({
        token: this.defaultToken
      }).then(data => {
        this.template = data
      });
    } else {
      this.template = this.profileTemplate;
    }
  },
  methods: {
    ...mapActions({
      getProfileTemplate: "profile/getProfileTemplate"
    }),
    setValue(value) {
      this.value = value;
      this.$emit("getValue", value);
    },
  },
};
</script>